import { useState } from 'react';
import { CalendarClock } from 'lucide-react';
import { DUE_TYPES, INTERVAL_OPTIONS, getIntervals, setInterval_ } from '../lib/maint';
import { getMode } from '../lib/profiles';

export default function MaintIntervals({ t }) {
  const [iv, setIv] = useState(getIntervals());
  const set = (k, v) => { setInterval_(k, v); setIv(getIntervals()); };
  return (
    <section className="set-sec" data-testid="maint-intervals">
      <h5><CalendarClock size={14} /> {t.mtIntervals}</h5>
      {(getMode() === 'garden' ? ['valve'] : DUE_TYPES).map((k) => (
        <div className="row price-row" key={k}>
          <span className="price-name">{(getMode() === 'garden' && t['mtGd_' + k]) || t['fit_' + k]}</span>
          <select data-testid={`maint-interval-${k}`} value={iv[k]} onChange={(e) => set(k, +e.target.value)}>
            {INTERVAL_OPTIONS.map((m) => <option key={m} value={m}>{`${m} ${t.mtMonths}`}</option>)}
          </select>
        </div>
      ))}
      <p className="muted small-hint">{(getMode() === 'garden' && t.mtGdHint) || t.mtIntervalsHint}</p>
    </section>
  );
}
